import { Box, MenuItem, Typography } from "@mui/material";

export const MenuItemButton = ({
  iconSrc,
  onClick,
  title,
  disabled,
}: {
  iconSrc?: string;
  title: string;
  onClick: () => any;
  disabled?: boolean;
}) => {
  return (
    <MenuItem
      sx={{
        display: "flex",
        gap: "8px",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {iconSrc && (
        <Box component={"img"} src={iconSrc} width={"20px"} height={"20px"} />
      )}
      <Typography>{title}</Typography>
    </MenuItem>
  );
};
